import { executeApp, executeAppAuth } from '@/utils/request'
import { AUTH, TENANTS } from '@/api/defineRouting'

export function loginApi<T = any>(data: any) {
  return executeAppAuth<T>('/auth', data, 'post')
}

export function logoutApi<T = any>(data: any) {
  return executeAppAuth<T>('/auth/logout', data, 'post')
}

export function loginByGoogle<T = any>(data: any) {
  return executeAppAuth<T>('/auth/loginByGoogle', data, 'post')
}

export function getListTenants<T = any>(data: any) {
  return executeApp<T>(TENANTS.LIST, data, 'get')
}

export function createUser<T = any>(data: any) {
  return executeAppAuth<T>(AUTH.CREATE_USER, data, 'post')
}

export function updateUserSystem<T = any>(data: any) {
  return executeAppAuth<T>(`${AUTH.UPDATE_USER_SYSTEM}?id=${data.id}`, data, 'put')
}

export function sendMailForAdmin<T = any>(data: any) {
  return executeAppAuth<T>(AUTH.SEND_MAIL_FOR_ADMIN, data, 'post')
}

export function verifyEmail<T = any>(data: { email: string; code: string }) {
  return executeAppAuth<T>(AUTH.VERIFY_EMAIL, data, 'get')
}

export function optForEmail<T = any>(data: any) {
  return executeAppAuth<T>(AUTH.OTP_FOR_EMAIL, data, 'get')
}

export function verifyOtp<T = any>(data: any) {
  return executeAppAuth<T>(AUTH.VERIFY_OTP, data, 'get')
}
export function forgotPassword<T = any>(data: any) {
  return executeAppAuth<T>(`${AUTH.FORGOT_PASSWORD}?email=${data.email}`, data, 'post')
}

export function checkAccount<T = any>(data: any) {
  return executeAppAuth<T>(AUTH.CHECK_ACCOUNT, data, 'post')
}

export function setAccountGoogle<T = any>(data: any) {
  return executeAppAuth<T>(AUTH.SET_ACCOUNT_GOOGLE, data, 'post')
}

export function updatePassword<T = any>(data: any) {
  return executeAppAuth<T>(`${AUTH.UPDATE_PASSWORD}?id=${data.id}`, data, 'put')
}

export function createUserAdmin<T = any>(data: any) {
  return executeAppAuth<T>(AUTH.CREATE_USER_ADMIN, data, 'post')
}
